<template>
  <tr v-if="is_deleted == false">
    <td>
      <!--<input type="checkbox" @click="select" v-model="item.select" :value="item.id"/>-->
      <div class="custom-control custom-checkbox">
        <input
          :id="item.id"
          v-model="item.select"
          type="checkbox"
          class="custom-control-input"
          name="select"
        >
        <label
          class="custom-control-label"
          :for="item.id"
        />
      </div>
    </td>
    <td
      class="position-relative"
      @mouseover="showImg = true"
      @mouseleave="showImg = false"
    >
      <a
        target="_blank"
        :href="$helper.url(item.id,item.name)"
      ><img
        :src="item.thumb"
        :size="100"
        class="thumb-xl thumb-pointer"
        aria-colspan="1"
      >
      </a>

      <image-big
        :id="item.id_row"
        :img="item.thumb"
        :show="showImg"
      />
    </td><td>
      <h5 class="mb-2">
        <router-link
          v-if="item.authorized"
          :to="{ name: 'edit_campaign', params: { id: item.id }}"
        >
          {{ item.name }}
        </router-link>
      </h5>
      <!--     <h5 v-if="!item.authorized">{{item.name}}</h5>-->
      <span class="alt">SKU:</span> <span> {{ item.sku }}</span> <br>
      <div class="d-flex mt-3">
        <span
          v-for="tag in item.tag"
          :key="tag"
          class="btn btn-sm btn-light mr-1 "
        >{{ tag }}</span>
      </div>
    </td>
    <!-- <td style="width: 25%">
        </td>-->
    <!-- <td>-</td>
         <td>-</td>
         <td>-</td>-->
    <td
      width="145"
      class="text-right"
    >
      <button
        v-if="item.authorized"
        class="btn btn-sm btn-light mr-2"
        @click="bulk(item)"
      >
        <i
          class="dripicons-copy"
        />
      </button>
      <button
        v-if="item.authorized"
        class="btn btn-sm btn-light"
        @click="remove(item)"
      >
        <i
          class="dripicons-trash"
        />
      </button>
    </td>
  </tr>
</template>

<script>
    import ImageBig from "./ImageBig";
    export default {
        name: "CampaignRow",
        components: {ImageBig},
        props: ['item'],
        data: function () {
            return {
                showImg:false,
                is_deleted: false
            }
        },
        watch: {
            'item.is_deleted': function (val) {
                if (val == true) {
                    this.is_deleted = true
                }
            }
        },
        methods: {
            bulk: function (item) {
                this.$router.push('/campaign/bulk/' + item.id)
            },
            select: function () {
                this.$emit('update', this.item)
            },
            remove: function (item) {
                let vm = this
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You cant revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        vm.$http.delete(vm.$config.api + 'campaign/' + item.id).then(function (res) {
                            vm.is_deleted = true
                        })
                      vm.$swal('Deleted', 'You successfully deleted this campaign', 'success')
                    } else {
                      vm.$swal('Cancelled', 'Your campaign is still intact', 'info')
                    }
                })
            },
            active: function () {

            }
        }

    }
</script>

<style scoped lang="scss">
    a {
        color:#000;
    }
    .alt {
        color: #aaa;
    }
    .tag {
        background-color: #8cb140;
        color: #fff;
        border-radius: 2px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 3px 5px;
        margin: 2px;
        font-size: .85em;
    }
</style>